/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_Streamerreport1Inputs */

const ja_playdata_nav_streamerreport1 = /** @type {(inputs: Playdata_Nav_Streamerreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーマーレポート`)
};

const en_playdata_nav_streamerreport1 = /** @type {(inputs: Playdata_Nav_Streamerreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streamer Report`)
};

/**
* | output |
* | --- |
* | "Streamer Report" |
*
* @param {Playdata_Nav_Streamerreport1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_nav_streamerreport1 = /** @type {((inputs?: Playdata_Nav_Streamerreport1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_Streamerreport1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_streamerreport1(inputs)
	return en_playdata_nav_streamerreport1(inputs)
});
export { playdata_nav_streamerreport1 as "playdata_nav_streamerReport" }